import React from 'react';
import './Modal.css';

export default function DiscardConfirmModal({ onDiscard, onKeepEditing }) {
  return (
    <div className="modal-overlay" style={{ zIndex: 1100 }} onClick={onKeepEditing}>
      <div className="modal" style={{ maxWidth: '360px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Discard Changes?</h2>
        </div>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', margin: '0 0 24px' }}>
          You have unsaved changes. If you close now, your changes will be lost.
        </p>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onKeepEditing}>
            Keep Editing
          </button>
          <button className="btn btn-danger" onClick={onDiscard}>
            Discard Changes
          </button>
        </div>
      </div>
    </div>
  );
}
